import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import { API_URL } from '../../config/apiEndpoints';

class TicketCarouselItem extends Component {

    getActiveStatus = () => {
        if (this.props.card.status === 3){
            return <Fragment>
                <span className={this.props.card.status === 3 ? "white-text" : ""}>
                    <Moment format="DD MMM" locale="ro" unix>
                        {this.props.card.date} 
                    </Moment>
                    { " " + this.props.card.hour}
                </span>
                <span className={ this.props.card.status === 3 ? "white-text" : "" }>{ this.props.card.cinema }</span>
            </Fragment> 
        }
    }

    render() {
        return (
            <div className="ticket-carousel-item">
                <img src={API_URL + this.props.card.imgSrc} alt="Bilet"/>
                <div className="ticket-details">
                    <span className="ticket-title db">{ this.props.card.title } <span>({ this.props.card.year })</span></span>
                    <span className="ticket-translation db grey-text">{this.props.card.subtitle}</span>
                    <div className="tkts ticket-icon active float-left">&nbsp;</div>
                    <div className="float-left ticket-dtls">
                        {/*<span className={ this.props.card.status === 3 ? "white-text bold" : "bold" }>Activ</span>*/}
                        {this.getActiveStatus()}
                        {/*<span className={ this.props.card.status === 4 ? "white-text bold" : "" }>Folosit</span>
                        <span className={ this.props.card.status === 5 ? "white-text bold" : "" }>Expirat</span>*/}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(TicketCarouselItem);





// WEBPACK FOOTER //
// ./src/SHARED/components/ticketcarouselitem/ticketcarouselitem.component.js